import { render, staticRenderFns } from "./ListarClassificacaoRefugado.vue?vue&type=template&id=692c07d9"
import script from "./ListarClassificacaoRefugado.vue?vue&type=script&lang=js"
export * from "./ListarClassificacaoRefugado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports